import './styles.scss';

import { Button } from 'react-bootstrap';

export type PageHeaderProps = {
  title: string;
  icon?: JSX.Element;
  subtitle?: string;
  info?: string;
  back?: string;
};

const PageHeader = ({ title, icon, subtitle, info, back }: PageHeaderProps): JSX.Element => {
  const onBack = () => window.history.back();

  return (
    <header className="PageHeader">
      {back && (
        <div className="PageHeader-Back">
          <Button variant="icon" onClick={onBack}>
            <span>
              <i className="fa fa-arrow-left" />
            </span>
            <span>{back}</span>
          </Button>
        </div>
      )}
      {icon && <div className="PageHeader-Icon">{icon}</div>}
      <div className="PageHeader-Content">
        <h2 className="PageHeader-Title">{title}</h2>
        {subtitle && <span className="PageHeader-Subtitle">{subtitle}</span>}
      </div>
      {info && <div className="PageHeader-Info">{info}</div>}
    </header>
  );
};

export default PageHeader;
